import React, {useCallback} from 'react'
import ListItem, {BaseProps} from './ListItem'
import {ColInfo, ColStat} from '../Col'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'
import {useNavigation} from '../../../utils/navigation'
import {URLItem as URLItemType} from "../../../../../types";

export enum URLStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export type URL = URLItemType

export type Props = {
  readonly url: URL
} & BaseProps

const URLItem: React.VFC<Props> = ({ onSelected, selected, options, url }) => {
  const { goTo } = useNavigation()

  const navigateToURL = useCallback(() => {
    // goTo(Routes.EditURL, { id: url.Id })
  }, [])

  return (
    <ListItem
      onClick={navigateToURL}
      options={options}>
      <ColInfo>
        <p className={classNames([styles.InfoBig, styles.Ellipsis])}>
          {url.name}
        </p>
      </ColInfo>
      <ColStat>
       {url.active ? 'Disabled' : 'Enabled'}
      </ColStat>
    </ListItem>
  )
}

export default URLItem
